import Axios, { AxiosResponse } from "axios";
import defineHeaderAxios from "@/utilities/useAuthToken";
import NmeaViewModel from "@/models/NmeaViewModel";

export default function () {
    const getNMEAData = async (): Promise<NmeaViewModel> => {
        await defineHeaderAxios();
        return new Promise((resolve, reject) => {
            Axios.get("/api/nmea")
                .then((result: AxiosResponse<NmeaViewModel>) => {
                    if (result.status === 200) {
                        resolve(result.data);
                    } else {
                        reject();
                    }
                })
                .catch((error) => {
                    console.log(error);
                    reject();
                });
        });
    };

    return {
        getNMEAData
    };
}
